/* Movatic WMS — Frontend | CesarFilho 932048016 */
import CrudList from '@/components/CrudList'

export default function Warehouses() {
  return (
    <CrudList
      title="Armazéns"
      endpoint="/api/core/warehouses/"
      columns={[
        { key: 'code', header: 'Código' },
        { key: 'name', header: 'Nome' },
        { key: 'site', header: 'Site', render: (r:any) => r.site?.code ?? r.site_code ?? '—' },
        { key: 'timezone', header: 'Timezone' },
      ]}
    />
  )
}
